import validate from 'jquery-validation';

export default function openBagDownload() {
  let open = '[data-openbagDownload]';
  let close = '[data-closebagDownload]';
  let bagDownload = $('[data-bagDownload]');
  let bagDownloadOpen = 'bagDownload--open';
  $(open).click((e) => {
    e.preventDefault();

    if (getCookie('modalDownQual')) {
      $('.qual').fadeIn();
      $('.qual').addClass("valid");
      $('.qual').prop("required", true);
    }

    $('.bagDownload__stage input[name="name"]').val(getCookie('modalDownName'));
    $('.bagDownload__stage input[name="email"]').val(getCookie('modalDownEmail'));
    $('.bagDownload__stage select[name="jaEClienteSoprano"]').val(getCookie('modalDownJaEClienteSoprano'));
    $('.bagDownload__stage input[name="qual"]').val(getCookie('modalDownQual'));
    $('.bagDownload__stage select[name="areaDeAtuacao"]').val(getCookie('modalDownAreaDeAtuacao'));

    bagDownload.addClass(bagDownloadOpen);
    $('body').css('overflow-y', 'hidden');
  });
  $(close).click(() => {
    if ($('.bagDownload__stage--success').is(':visible')) {
      location.reload();
    } else {
      bagDownload.removeClass(bagDownloadOpen);
      $('body').css('overflow-y', 'auto');
    }
  });

  $('.bagDownload-clear-downloads').click(function (e) {
    e.preventDefault();
    var btn = $(this);
    $.ajax({
      url: btn.attr('href'),
      type: 'GET',
      dataType: 'json',
      complete: function () {
        location.reload();
      }
    });
  });

  $('.jaEClienteSoprano').change(function () {
    if ($(this).val() == 'Outro') {
      $('.qual').fadeIn();
      $('.qual').addClass("valid");
      $('.qual').prop("required", true);
    } else {
      $('.qual').fadeOut();
      $('.qual').removeClass("valid");
      $('.qual').prop('required',false);
    }
  });

  let contentForm = $('[data-formvalidatecardownloads]');
  if (contentForm.length) {
    contentForm.each(function (index, el) {
      $(this).on("submit", function(e){
        e.preventDefault();

        var form = $(this);

          grecaptcha.ready(function () {
            grecaptcha.execute('6LdIr9sZAAAAADlV6TRsdi3aWTuw19tI6ZPilj1-', {
              action: 'submit'
            }).then(function (token) {

              var match = document.cookie.match(new RegExp('(^| )' + '__trf.src' + '=([^;]+)'));
              var traffic_source = '';
              if (match){
                traffic_source = match[2];
              }

              var data;
              var contentType = "application/x-www-form-urlencoded";
              var processData = true;
              $('.modalLoader .modalLoader__text').text(jsi18n.loading_download);
              $('.modalLoader').show();
              data = $(form).serialize()+'&gRecaptchaResponse='+ token +'&traffic_source='+ traffic_source;
              $.ajax({
                data: data,
                type: $(form).attr('method'),
                url: $(form).attr('action'),
                dataType: 'json',
                mimeType: 'text/plain; charset=x-user-defined',
                contentType: contentType,
                processData: processData,
                beforeSend: function () {
                  $(form).find('button').addClass('load');
                  $(form).find('input,button').prop("disabled", true);
                },
                success: function (data) {

                  var cookieName = $(".bagDownload__stage input[name='name']").val();
                  var cookieEmail = $('.bagDownload__stage input[name="email"]').val();
                  var cookieJaEClienteSoprano = $('.bagDownload__stage select[name="jaEClienteSoprano"]').val();
                  var cookieQual = $('.bagDownload__stage input[name="qual"]').val();
                  var cookieAreaDeAtuacao = $('.bagDownload__stage select[name="areaDeAtuacao"]').val();

                  if (cookieJaEClienteSoprano != 'Outro') {
                    cookieQual = '';
                  }

                  setCookie('modalDownName', cookieName, 30);
                  setCookie('modalDownEmail', cookieEmail, 30);
                  setCookie('modalDownJaEClienteSoprano', cookieJaEClienteSoprano, 30);
                  setCookie('modalDownQual', cookieQual, 30);
                  setCookie('modalDownAreaDeAtuacao', cookieAreaDeAtuacao, 30);

                  $('.modalLoader').hide();
                  $('.modalLoader .modalLoader__text').text(jsi18n.loading);

                  if (data.status) {
                    window.open(data.url, '_blank');
                  } else {
                    Swal.fire({
                      title: jsi18n.form_invalid_title,
                      html: data.msgWarning,
                      imageUrl: site_url + 'site/img/iconError.png',
                      imageWidth: 76,
                      imageHeight: 76
                    });
                    $(form).find('input,button').prop("disabled", false);
                    $(form).find('button').removeClass('load');
                  }

                  $(form)[0].reset();
                  let contentForm = $('.bagDownload__form');
                  let formSuccess = $('.bagDownload__stage--success');
                  contentForm.hide();
                  formSuccess.fadeIn();
                },
                error: function (data) {
                  $('.modalLoader').hide();
                  $('.modalLoader .modalLoader__text').text(jsi18n.loading);
                  Swal.fire({
                    title: jsi18n.form_invalid_title,
                    html: data.msgWarning,
                    imageUrl: site_url + 'site/img/iconError.png',
                    imageWidth: 76,
                    imageHeight: 76
                  });
                  $(form).find('input,button').prop("disabled", false);
                  $(form).find('button').removeClass('load');
                }
              });

            });

          });
        
        });
    });
  }

  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function eraseCookie(name) {
    document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }

  $(".bagDownload__btnNext.slick-next").click(function() {
    var nome = $(".nome").val();
    var email = $(".nome").val();
    var jacliente = $(".jaEClienteSoprano option:selected").val();
    var area = $(".areaatuacao option:selected").val();
    if(nome != '' && email != '' && jacliente != null && area!= null ){
      $(".concluir").css({
        "display" : "block"
      });
      $(".preencha").css({
        "display" : "none"
      });
    }else{
      $(".concluir").css({
        "display" : "none"
      });
      $(".preencha").css({
        "display" : "block"
      });
    }
  });

  $(function() {
		$(".nome, .email, .jaEClienteSoprano, .areaatuacao").on('change', function() {
			if ($(this).closest('form').find('.nome').is(':valid') && $(this).closest('form').find('.email').is(':valid') && $(this).closest('form').find('.jaEClienteSoprano').val() && $(this).closest('form').find('.areaatuacao').val()) {
				$(this).closest('form').find(".concluir").css({
					"display" : "block"
				});
				$(this).closest('form').find(".preencha").css({
					"display" : "none"
				});
			} else {
				$(this).closest('form').find(".concluir").css({
					"display" : "none"
				});
				$(this).closest('form').find(".preencha").css({
					"display" : "block"
				});
			}
		});
	});

}